import { render } from "./ProjectStats.vue?vue&type=template&id=87a8a968&scoped=true"
import script from "./ProjectStats.vue?vue&type=script&lang=js"
export * from "./ProjectStats.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-87a8a968"

export default script